import store from '@/store'
import siteregularCtms from './siteregularCtms'
import project from './project'
import workHoursInfo from './workHoursInfo'
import contract from './contract'
import system from './system'
import worktime from './worktime'
import login from './login'
import Vue from 'vue'
import VueRouter from 'vue-router'
import worktimeDingDing from './worktimeDingDing';
import mobileWeCom from './mobileWeCom';
import hospital from './hospital'
import statistic from './statistic'
import download from './download'
import finance from './finance'
import personnel from "./personnel";
import quote from './quote'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: 'homeLayout' */'@/views/home/layout/index'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'workbench',
        component: () => import(/* webpackChunkName: 'workbench' */'@/views/home/workbench/newIndexStrg')
      },
      {
        path: '/messageCenter',
        name: 'messageCenter',
        component: () => import(/* webpackChunkName: 'messageCenter' */'@/views/message/index')
      }
    ]
  },
  {
    path: '/dashboard',
    component: () => import(/* webpackChunkName: 'homeLayout' */'@/views/homeNew/layout/index'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: 'dashboard' */'@/views/homeNew/workbench/index')
      }
    ]
  }
  , login
  , worktime
  , system
  , project
  , workHoursInfo
  , contract
  , personnel
  , siteregularCtms
  , ...worktimeDingDing
  , ...mobileWeCom
  , hospital
  , statistic
  , download
  , finance
  , quote
  , {
    path: '/permission-test',
    name: 'PermissionTest',
    component: () => import(/* webpackChunkName: "permission-test" */ '@/views/login/PermissionTest.vue'),
    meta: { title: '权限测试', requiresAuth: true }
  }
  , {
    path: '/permission-verify',
    name: 'PermissionVerify',
    component: () => import(/* webpackChunkName: "permission-verify" */ '@/views/login/PermissionVerify.vue'),
    meta: { title: '权限验证', requiresAuth: true }
  }
  , {
    path: '*',
    name: 'error-page',
    component: () => import(/* webpackChunkName:'error_page' */ '@/views/error-page/index')
  }
]
const router = new VueRouter({
  routes
})
// 移动端分发：企业微信 + 手机设备 → 强制走移动端；放行 /login 让 OAuth 免登完成
const _ua = navigator.userAgent.toLowerCase()
const _isWeCom = /wxwork/i.test(_ua)
const _isMobileDevice = /android|iphone|ipad|ipod|mobile|windows phone/i.test(_ua)
const isWeComMobile = _isWeCom && _isMobileDevice
router.beforeEach((to, from, next) => {
  if (isWeComMobile && !to.path.startsWith('/mobileWeCom') && to.path !== '/login') {
    return next({ path: '/mobileWeCom' })
  }
  next()
})
// 全局路由守卫
//let loadingInstance = null
router.beforeEach((to, from, next) => {
  // 判断 to 路由是否需要进行身份认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.user.token) {
      return next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  }
  next()
})
router.afterEach(() => {
  //if (loadingInstance) loadingInstance.close()
})
router.onError((error) => {
  const pattern = /Loading chunk +/g;
  const pattern1 = /Unexpected token /g;
  // const isChunkLoadFailed = error.message.match(pattern) ||  error.message.match(pattern1) ;
  if (error.message.match(pattern) || error.message.match(pattern1)) {
    window.location.reload();
    // router.replace(router.history.pending.fullPath);
  } else {
    console.log(error)
  }
});
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export default router
